export const productsDescriptions = {
  withSalesData: 'Desglose de las devoluciones por producto, sobre las unidades totales vendidas de cada uno.',
  withoutSalesData: 'Qué parte de todas las unidades devueltas corresponde a cada producto.',
}
